import React, { useState, useEffect } from 'react';
import moment from 'moment';
import './dadospaciente.scss';

import IconCPF from '../../assets/svg/dadospaciente/ic-ecommerce-card.svg';
import IconIdade from '../../assets/svg/dadospaciente/ic-users-time.svg';
import IconProfissao from '../../assets/svg/dadospaciente/ic-medicine-heart-hear.svg';
import IconNasc from '../../assets/svg/dadospaciente/ic-actions-calendar.svg';
import IconCor from '../../assets/svg/dadospaciente/ic-editor-color.svg';
import IconSexo from '../../assets/svg/dadospaciente/sexo.svg';
import IconPhone from '../../assets/svg/dadospaciente/ic-contact-phone.svg';
import IconEmail from '../../assets/svg/dadospaciente/ic-contact-mail.svg';
import IconDoenca from '../../assets/svg/dadospaciente/ic-medicine-patch.svg';

const noImage = 'https://firebasestorage.googleapis.com/v0/b/globalbrain-ba498.appspot.com/o/images%2Fno-user.jpg?alt=media&token=44616cc9-46e2-40ea-906f-28e46f58fb68';

const DadosPaciente = (dados) => {

    const [visible, setVisible] = useState(dados.visible);
    const [responsavel, setResponsavel] = useState(dados.responsavel);

    useEffect(() => {
        setVisible(dados.visible);
    }, [dados.visible])

    useEffect(() => {
        setResponsavel(dados.responsavel);
    }, [dados.responsavel]);

    useEffect(() => {
        console.log(dados);
        if (dados.setVisible) {
            dados.setVisible(visible);
        }
    }, [visible])

    const calcularIdade = data => {
        var today = new Date();
        var birthDate = new Date(data); // create a date object directly from `data` argument
        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age_now--;
        }

        return age_now;
    };

    // maxHeight: visible ? 'none' : '145px',
    // boxShadow: visible ? '0px 13px 60px black' : '',
    // zIndex: visible ? 10 : 0,
    // animation: 'all .3s ease'
//row
    // style={{
    //     // maxHeight: visible ? 'none' : '145px',
    //     // background: visible ? 'rgb(67, 89, 102)' : '',
    //     // animation: 'all .3s ease'
    // }}
    return (
        <div className="gb-cont-paciente">
            <div className="gb-cont-card-paciente">
                {responsavel ? (
                    <div>
                        <div className="gb-medico-responsavel">
                            <i className="fa fa-user-md"></i>{" "}
                            {dados.proprioResponsavel ? (
                                <>
                                    Você é o responsável por este paciente!
                                    <button className="gb-button-flat float-right" onClick={() => { if (dados.abandonarPaciente) dados.abandonarPaciente() }}>
                                        <i className="fa fa-times"></i> Abandonar
                                    </button>
                                </>
                            ) : (
                                responsavel ? (
                                    <>Médico Responsável: {responsavel.nome}</>
                                ) : null
                            )}
                        </div>
                    </div>
                ) : null}


            <div className="gb-card-paciente-row" >
                <div className="cont-photo">
                    <div className="gb-card-paciente-foto">
                            <img src={dados.paciente.paciente.avatarURL ? dados.paciente.paciente.avatarURL : noImage} className="rounded-circle" alt="user" />
                            
                        </div>
                        <button className="btn bt-sm btn-warning btn-block" onClick={() => { window.location.href ='/paciente/editar/'+dados.paciente.id}}><i className="fa fa-edit" /> Editar</button>
                </div>
                <div className="gb-coluna">
                    <div className="gb-card-paciente-title">
                        {dados.paciente.paciente.nome.substr(0, 43)}
                    </div>
                    <div className="gb-linha">
                        <div className="gb-coluna">
                            <div className="gb-linha">
                                <img src={IconCPF} />
                                <strong>CPF:</strong>
                                {dados.paciente.paciente.cpf}
                            </div>

                            <div className="gb-linha">
                                <img src={IconIdade} />
                                <strong>Idade:</strong>
                                {calcularIdade(dados.paciente.paciente.nascimento)}
                            </div>

                            <div className="gb-linha">
                                <img src={IconProfissao} />
                                <strong>Profissão:</strong>
                                {dados.paciente.paciente.profissao}
                            </div>

                            <div className="gb-linha">
                                <img src={IconNasc} />
                                <strong>Data Nasc.:</strong>
                                {moment(dados.paciente.paciente.nascimento).format("DD/MM/YYYY")}
                            </div>
                            {/* <p>
                                Naturalidade:{" "}
                                {dados.paciente.paciente.naturalidade}
                            </p> */}
                            
                        </div>

                        <div className="gb-coluna gb-p gb-moredados">

                            <div className="gb-linha">
                                <img src={IconCor} />
                                <strong>Cor Declarada:</strong>
                                {dados.paciente.paciente.cor}
                            </div>

                            <div className="gb-linha">
                                <img src={IconSexo} />
                                <strong>Sexo:</strong>
                                {dados.paciente.paciente.sexo}
                            </div>

                            <div className="gb-linha">
                                <img src={IconPhone} />
                                <strong>Telefone:</strong>
                                {dados.paciente.paciente.telefones}
                            </div>

                            <div className="gb-linha">
                                <img src={IconEmail} />
                                <strong>Email:</strong>
                                {dados.paciente.paciente.email}
                            </div>

                            {/* {` ${dados.paciente.paciente.cidade} - ${dados.paciente.paciente.uf}`}
                            <br />
                            Bairro: {dados.paciente.paciente.bairro}
                            <br />
                            {dados.paciente.paciente.logradouro} */}
                            

                        </div>
                        <div className="gb-coluna gb-p gb-cronic">

                            <div className="gb-linha">
                                <img src={IconDoenca} />
                                <strong>Doenças [CID's]: </strong>
                            </div>
                            {dados.paciente.paciente.doencas
                                    ? dados.paciente.paciente.doencas.map(
                                        (doenca, index) => {
                                            return <div key={index}>{`${index + 1}º ${doenca.codigo} ${doenca.doenca}`}<br/></div>;
                                        }
                                    )
                                : null}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    )
}

export default DadosPaciente;